import { createApp,ref } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/globe.less";


import "./utils/flexible";
import "./utils/china";
import utils from "./utils/common";
import dataV from '@jiaminghi/data-view'
import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css
import 'animate.css';
import "echarts-liquidfill";
import BaiduMap from 'vue-baidu-map-3x'
import axios from "axios";
// app.use(vue3videoPlay) 
// import scroll from 'vue-seamless-scroll'
// Vue.use(scroll)



import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
const app = createApp(App);

 

const globalVariable = ref('https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img');
// const AccessToken= "at.aqhd51mc2wnbpg8l54njcwb3busv8vru-54xjo35az2-1tbll4a-ipp2utua8";
app.config.globalProperties.$globalVariable = globalVariable;

async function getToken(state){
  // localStorage.setItem('AccessToken', 'at.dj3xvud05r8xkayd8qvksiofdc2pad3u-8z6jxva1gf-09utm1v-mwpsczrd0');
    axios
      .get("https://zhfarm.laicunwang.com/api/environment/getcamera11", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
      .then((res) => {
          console.log(res);
          // state.AccessToken = res.data.data.data.accessToken
          localStorage.setItem('AccessToken', res.data.data.accessToken);
      });
}
getToken()
app.use(BaiduMap,{// ak 是在百度地图开发者平台申请
    ak:'D13xI9XvcWECLBL5mp8uRSGuAmdB6GXQ',
});
app.use(store);
app.use(dataV);
// app.use(scroll);
app.use(router);
app.use(ElementPlus)
app.use(vue3videoPlay)
// app.provide('AccessToken', AccessToken)
app.config.globalProperties.$utils = utils;
app.mount("#app");

